import { AdminReturnWorkflowStatus } from "@redotech/redo-model/temporal/workflow-status";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const upsertWorkflowStatus = {
  name: "upsertWorkflowStatus" as const,
  input: z.object({
    teamId: zExt.objectId(),
    returnId: zExt.objectId(),
    workflowId: z.string(),
    workflowType: z.string(),
    status: createEnum(AdminReturnWorkflowStatus),
    message: z.string().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
